<template>
  <div>
    <!-- Add placeholder -->
    <b-form-group
      :label="$t('risk.template.placeholder_value')"
      label-for="placeholder-value"
    >
      <b-form-input
        id="placeholder-value"
        v-model.trim="placeholderValue"
        @input="onInputChange"
      />
      <div class="popover-wrapper">
        <small class="form-text text-muted">
          {{ $t("risk.template.placeholder_available") }}:
          @FECHA,
          @HORA,
          @FECHA_HORA,
          @REFERENCIA,
          @SOEID,
          @NOMBRE,
          @PUESTO,
          @EMAIL,
        </small>
        <small class="form-text text-muted">
          {{ $t("risk.template.placeholder_separator_hint") }}
        </small>
        <div class="popover-manual">
          <h6 class="font-weight-bold">Formato de Tags</h6>
          <small class="text-muted d-block">Fecha y hora</small>
          <table class="table table-sm table-bordered mb-1">
            <thead>
              <tr>
                <th class="py-1 px-2">Tag</th>
                <th class="py-1 px-2">Significado</th>
                <th class="py-1 px-2">Ejemplo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="px-2"><code>@FECHA</code></td>
                <td class="px-2">Fecha del dia en formato yyyy-mm-dd</td>
                <td class="px-2">2025-12-01</td>
              </tr>
              <tr>
                <td class="px-2"><code>@HORA</code></td>
                <td class="px-2">Hora actual en formato hh-mm-ss</td>
                <td class="px-2">14:57:42</td>
              </tr>
              <tr>
                <td class="px-2"><code>@FECHA_HORA</code></td>
                <td class="px-2">Fecha y hora actual</td>
                <td class="px-2">2025-12-01 14:57:42</td>
              </tr>
              <tr>
                <td class="px-2"><code>@REFERENCIA</code></td>
                <td class="px-2">Numero de referencia</td>
                <td class="px-2">024 026</td>
              </tr>
              <tr>
                <td class="px-2"><code>@SOEID</code></td>
                <td class="px-2">SOEID de empleado que contesta formulario</td>
                <td class="px-2">Admin</td>
              </tr>
              <tr>
                <td class="px-2"><code>@NOMBRE</code></td>
                <td class="px-2">Nombre de empleado que contesta formulario</td>
                <td class="px-2">Admin</td>
              </tr>
              <tr>
                <td class="px-2"><code>@PUESTO</code></td>
                <td class="px-2">Puesto de empleado que contesta formulario</td>
                <td class="px-2">Supervisor</td>
              </tr>
              <tr>
                <td class="px-2"><code>@EMAIL</code></td>
                <td class="px-2">Email de empleado que contesta formulario</td>
                <td class="px-2">Supervisor@omnilcoud.com</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    // Parent passes data that is the placeholder object
    data: {
      type: Object,
      default: () => ({ data: [] }),
    },
    config: Object,
  },
  data() {
    return {
      placeholderValue: "",
    };
  },
  created() {
    const existing = this.data?.data?.[0];
    if (existing && existing.value) {
      this.placeholderValue = existing.value;
    }
  },
  methods: {
    onInputChange() {
      const value = this.placeholderValue;

      // Emit the value as a single string with comma/dash separated values
      this.$emit("update:data", {
        data: value ? [{ value }] : [],
      });
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const existing = newVal?.data?.[0];
        if (
          existing &&
          existing.value &&
          existing.value !== this.placeholderValue
        ) {
          this.placeholderValue = existing.value;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

::v-deep {
  .dark-layout {
    .form-group label {
      color: $theme-dark-label-color;
    }

    .form-text {
      color: $theme-dark-text-muted-color !important;
    }

    .form-control {
      background-color: $theme-dark-input-bg;
      border-color: $theme-dark-input-border-color;
      color: $theme-dark-body-color;

      &::placeholder {
        color: $theme-dark-input-placeholder-color;
      }

      &:focus {
        background-color: $theme-dark-card-bg;
        border-color: var(--primary);
        color: $theme-dark-headings-color;
      }
    }
  }
}
.popover-content table {
  font-size: 12px;
}
.popover-content code {
  font-weight: bold;
}
.popover-content {
  max-height: 400px;
  overflow-y: auto;
}
.popover-wrapper {
  position: relative;
  display: inline-block;
}

.info-icon {
  cursor: pointer;
  display: inline-block;
}

.popover-manual {
  position: absolute;
  top: 50%;
  left: calc(40% + 8px);
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  width: 500px;
  max-width: none;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);

  z-index: 100;
  opacity: 0;
  pointer-events: none;
  transition: opacity .15s ease;
}

.popover-wrapper:hover .popover-manual {
  opacity: 1;
  pointer-events: auto;
}
</style>
